/* ─────────  Spotify API  ───────── */
const CLIENT_ID     = 'b111791994a249cfa8e4c12be8c5826c';
const CLIENT_SECRET = 'f8bc97bed16f4c20906a1afd656e8a8e';
let token = '', exp = 0;

async function getToken () {
  if (Date.now() < exp) return token;
  const r = await fetch('https://accounts.spotify.com/api/token', {
    method : 'POST',
    headers: {
      'Authorization': 'Basic ' + btoa(CLIENT_ID + ':' + CLIENT_SECRET),
      'Content-Type' : 'application/x-www-form-urlencoded'
    },
    body: 'grant_type=client_credentials'
  });
  const d = await r.json();
  token = d.access_token;
  exp   = Date.now() + (d.expires_in - 60) * 1000;
  return token;
}

async function searchTracks (q) {
  const r = await fetch(
    `https://api.spotify.com/v1/search?q=${encodeURIComponent(q)}&type=track&limit=6`,
    { headers: { Authorization: 'Bearer ' + await getToken() } }
  );
  return (await r.json()).tracks.items;
}

/* ─────────  UI / EVENTS  ───────── */
document.addEventListener('DOMContentLoaded', () => {

  /* Özelleştirme butonu olmayan sayfalarda çık */
  const openBtn = document.getElementById('customizeBtn');
  if (!openBtn) return;

  /* Modal & form referansları */
  const modal      = document.getElementById('customModal'),
        contentBox = modal.querySelector('.custom-modal__content'),
        closeBtn   = document.getElementById('closeModal'),   // <button type="button">
        form       = document.getElementById('customForm'),

        songInp    = document.getElementById('songSearch'),
        songBtn    = document.getElementById('songBtn'),
        list       = document.getElementById('songResults'),

        photoUp    = document.getElementById('photoUpload'),
        cropWrap   = document.getElementById('cropWrap'),
        rawImg     = document.getElementById('rawImg'),
        applyCrop  = document.getElementById('applyCrop'),
        previewWrap= document.getElementById('previewWrap'),
        songProp   = document.getElementById('songProp');

  /* ✦ Ön-izleme kartını tek seferde yerleştir */
  previewWrap.innerHTML = `
    <div class="magnet-card">
      <img id="photoPreview" alt="">
      <span class="heart"></span>

      <div class="info-zone">
        <div id="songName"   class="song-name">Şarkı</div>
        <div id="songArtist" class="song-artist">Sanatçı</div>

        <div class="bar">
          <span id="curTime" class="time">0:00</span>
          <div class="progress"><span id="fillBar" class="fill"></span></div>
          <span id="totTime" class="time">0:30</span>
        </div>

        <div class="controls">
          <span class="ctl shuffle"></span>
          <span class="ctl back"></span>
          <button id="playBtn" type="button" class="play"></button>
          <span class="ctl next"></span>
          <span class="ctl repeat"></span>
        </div>
      </div>
    </div>
    <audio id="audioEl" preload="none" class="hidden"></audio>`;

  /* Kart içi referanslar */
  const photoPrev  = document.getElementById('photoPreview'),
        songNameEl = document.getElementById('songName'),
        artistEl   = document.getElementById('songArtist'),
        curTimeEl  = document.getElementById('curTime'),
        totTimeEl  = document.getElementById('totTime'),
        fillBar    = document.getElementById('fillBar'),
        playBtn    = document.getElementById('playBtn'),
        audioEl    = document.getElementById('audioEl');

  let cropper, deb;

  /* ─────  Modal AÇ  ───── */
  openBtn.addEventListener('click', () => {
    modal.classList.remove('hidden');
  });

  /* ─────  Modal KAPAT ortak fonksiyonu  ───── */
  function hideModal() {
    /* form & ön-izlemeyi sıfırla */
    form.reset();
    list.innerHTML   = ''; list.style.display = 'none';
    photoPrev.src    = '';
    songNameEl.textContent = 'Şarkı';
    artistEl.textContent   = 'Sanatçı';
    curTimeEl.textContent  = '0:00';
    fillBar.style.width    = '0%';

    audioEl.pause(); audioEl.removeAttribute('src');
    if (cropper) { cropper.destroy(); cropper = null; }
    cropWrap.classList.add('hidden');

    modal.classList.add('hidden');
  }

  /* ✕ butonu */
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();          // form’a kabarcık gitmesin
    hideModal();
  });

  /* ESC ile kapatma */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) hideModal();
  });

  /* Arka plan tıklaması */
  modal.addEventListener('click', (e) => {
    if (e.target === modal) hideModal();
  });
  /* İçerik tıklamasında kapanmasın */
  contentBox.addEventListener('click', (e) => e.stopPropagation());

  /* ─────  Fotoğraf yükle & kırp  ───── */
  photoUp.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    rawImg.src = URL.createObjectURL(file);
    cropWrap.classList.remove('hidden');

    cropper && cropper.destroy();
    cropper = new Cropper(rawImg, {
      aspectRatio: 1,
      viewMode   : 1,
      dragMode   : 'move',
      responsive : true
    });
  });

  applyCrop.addEventListener('click', () => {
    if (!cropper) return;
    const canvas = cropper.getCroppedCanvas({ width:800, height:800 });
    photoPrev.src = canvas.toDataURL('image/jpeg', 0.9);
    cropWrap.classList.add('hidden');
    cropper.destroy(); cropper = null;
  });

  /* ─────  Spotify Arama  ───── */
  async function searchAndShow () {
    const q = songInp.value.trim();
    if (!q) { list.style.display = 'none'; return; }
    const tracks = await searchTracks(q);

    list.innerHTML = tracks.map(t => `
      <li data-name="${t.name}"
          data-artist="${t.artists[0].name}"
          data-prev="${t.preview_url || ''}">
        <img src="${t.album.images[t.album.images.length-1]?.url || ''}" alt="">
        ${t.name} – ${t.artists[0].name}
      </li>`).join('');
    list.style.display = 'block';
  }

  songBtn.addEventListener('click', searchAndShow);
  songInp.addEventListener('keyup', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); searchAndShow(); return; }
    clearTimeout(deb); deb = setTimeout(searchAndShow, 400);
  });

  list.addEventListener('click', (e) => {
    const li = e.target.closest('li');
    if (!li) return;

    const { name, artist, prev } = li.dataset;
    songNameEl.textContent = name;
    artistEl.textContent   = artist;
    songProp.value         = `${name} - ${artist}`;

    totTimeEl.textContent  = '0:30';
    curTimeEl.textContent  = '0:00';
    fillBar.style.width    = '0%';

    if (prev) {
      audioEl.src = prev;
      audioEl.currentTime = 0;
      audioEl.play();
      playBtn.classList.add('pause');
    }

    songInp.value = `${name} – ${artist}`;
    list.style.display = 'none';
  });

  /* ─────  Oynat / Duraklat  ───── */
  playBtn.addEventListener('click', () => {
    if (!audioEl.src) return;
    if (audioEl.paused) { audioEl.play();  playBtn.classList.add('pause'); }
    else                { audioEl.pause(); playBtn.classList.remove('pause'); }
  });

  audioEl.ontimeupdate = () => {
    const ratio = audioEl.duration ? audioEl.currentTime / audioEl.duration : 0;
    fillBar.style.width   = (ratio * 100).toFixed(1) + '%';
    curTimeEl.textContent = '0:' + String(Math.floor(audioEl.currentTime)).padStart(2,'0');
  };
  audioEl.onended = () => playBtn.classList.remove('pause');

  /* ─────  Form → Sepete Ekle  ───── */
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();

    const fd = new FormData(form);
    const variantId = document.querySelector('form[action^="/cart/add"] [name="id"]').value;
    fd.append('id', variantId);

    const r = await fetch('/cart/add.js', { method:'POST', body:fd });
    if (r.ok) {
      hideModal();            // modalı kapat
      window.location = '/cart';
    } else {
      alert('Sepete eklenemedi, lütfen tekrar deneyin.');
    }
  });

});   // DOMContentLoaded
